import { PieceDTO, PieceResponseDTO } from "../openapi-generated-client";

function convertPieceResponseDTOToPieceDTO(responseDTO: PieceResponseDTO) {
    const pieceDTO = responseDTO as unknown as PieceDTO;
    if(pieceDTO.orchestralInstruments == undefined ||  pieceDTO.orchestralInstruments.length == 0) {
        pieceDTO.orchestralInstruments = undefined;
    }
    if(responseDTO.performances != undefined && responseDTO.performances.length > 0) {
        for(var i = 0; i < responseDTO.performances.length; i++) {
            var current = responseDTO.performances[i];
            if(current.performer.name != undefined) {
                pieceDTO.performances[i].performerName = current.performer.name;
                pieceDTO.performances[i].performerId = current.performer.id;
            }
        }   
    }
    return pieceDTO;
}

function convertPieceDTOToPieceResponseDTO(dto: PieceDTO) {
    return dto as unknown as PieceResponseDTO;
}

export { convertPieceResponseDTOToPieceDTO, convertPieceDTOToPieceResponseDTO };